// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "1.0.1713804066/css/" + chunkId + "." + {"613":"4058a043","744":"0110caad"}[chunkId] + ".chunk.css";
};